import { render, staticRenderFns } from "./ModalInsertEvent.vue?vue&type=template&id=dea8b840"
import script from "./ModalInsertEvent.vue?vue&type=script&lang=js"
export * from "./ModalInsertEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports